import React from "react";
import {useTranslation} from "react-i18next";
import Notification, {NOTIFICATION_TYPE} from "../../../../../../../../../../../../common/notification";
import '../../cu-tr.scss';

type NotificationInfoProps = {
    documents: DocumentsByCodeItemsDocs;
}

export const NotificationInfo = ({documents} : NotificationInfoProps) => {

  const { t } = useTranslation()

  const hasRequiredDocuments = Object.keys(documents.required).length > 0;

  const docs =
        hasRequiredDocuments
          ? Object.values(documents.required)
          : Object.values(documents.variant);

  return <Notification
    sx={{ marginTop: 3 }}
    type={NOTIFICATION_TYPE.INFO}
    title={
      hasRequiredDocuments ?
        t('dictionaries__text__certification__youWillNeedToCompleteTheFollowingDocuments'):
        t('dictionaries__text__certification__youWillNeedToCompleteOneOfTheTheFollowingDocuments')}
    noCloseButton
    text={<ul className='cu-tr__list'>
      {docs?.map((value, index) => (
        <li className='cu-tr__list-item' key={value}>
          {value}
        </li>))}
    </ul>}
  />
}
